module.exports = __webpack_public_path__ + "static/media/OurCompany2-EN.54c75dbe.png";